import { PersonCircle } from "react-bootstrap-icons";

export const testimonial1 = [
  {
    id: 21,
    avatar: <PersonCircle size={40} />,
    name: "Maria Rosario Manuel Cayabyab",
    designation: `An excellent travel agent!`,
    text: `Thank you Sanam for organizing such a wonderful trip; everything was seamless and we felt so well taken care of.
    In addition, you went beyond your duties to make sure that we had a great time, thanks for checking on us during our cruise.
    Hopefully, we are able to use your agency again for our future trips. Thank you!`,
    dealyAnimation: "200",
    date_posted: "Jan 21, 2026"
  },
  {
    id: 20,
    avatar: <PersonCircle size={40} />,
    name: "Kayla C",
    designation: `Family Cruise to the Bahamas!`,
    text: `We had an absolutely amazing experience working with Roave Travel for our family vacation! From start to finish, everything was handled seamlessly — flights, hotel, and cruise were all perfectly coordinated, which made the entire trip completely stress-free for us.
    What truly stood out was their responsiveness. No matter the time of day, every question and request we had was answered quickly and thoroughly. When complications or last-minute inquiries came up, they were handled with professionalism, patience, and genuine care. We always felt supported and confident that everything was under control.
    Thanks to their attention to detail and dedication, our family of 10+ people was able to relax and fully enjoy our vacation. We would highly recommend Roave Travel to anyone looking for a knowledgeable, reliable, and responsive travel agent.`,
    dealyAnimation: "200",
    date_posted: "Jan 21, 2026"
  },
  {
    id: 19,
    avatar: <PersonCircle size={40} />,
    name: "Pragati",
    designation: `I recently booked my family trip to Cancun`,
    text: `I recently booked my family trip to Cancún through Sanamdeep, and I couldn’t be happier with the experience. From the very beginning, he took care of everything flights, transfers, and all the little details so we didn’t have to stress about a thing.
    The entire process was smooth, well-organized, and stress-free. Our airport transfers were on time, our flights were well-coordinated, and everything went exactly as planned. Sanamdeep was always available to answer questions quickly and made sure we were comfortable with every step of the trip.`,
    dealyAnimation: "200",
    date_posted: "Sep 30, 2025"
  },
  {
    id: 18,
    avatar: <PersonCircle size={40} />,
    name: "Jay Sohi",
    designation: `High experiences low prices`,
    text: `Every aspect of our trip was beautifully laid out and it all came together like a seamless symphony of music. These guys took our ideas and turned them into even better realities for our trip. Not only that, but the prices for the hotel, the rental car, and even the activities we booked were astonishingly low! I must say that our trip was always going to be memorable, but Roave made the trip unforgettable.    `,
    dealyAnimation: "200",
    date_posted: "June 11, 2025"
  },
  {
    id: 17,
    avatar: <PersonCircle size={40} />,
    name: "Zannatul Tazrin",
    designation: `Best Experience`,
    text: `We had a fantastic experience with Roave Travel! They made our hotel booking process smooth and hassle-free, and the price they secured for us was unbeatable. The staff was professional, responsive, and genuinely helpful throughout. Everything went exactly as planned. Highly recommend for stress-free travel planning!`,
    dealyAnimation: "200",
    date_posted: "February 17, 2025"
  },
  {
    id: 16,
    avatar: <PersonCircle size={40} />,
    name: "Harpreet",
    designation: `Roave was extremely easy to work with…`,
    text: `Roave was extremely easy to work with for my Trip to Italy recently. All my travel plans were booked with great consideration for my preferred hotel choices and locations. Alternatives options were brought to my attention if costs could be reduced for my trip which went beyond what I had experienced with other travel sites in the past. My trip itinerary was made available to me on an app system with all the hotel confirmations and flight/train details which was super convenient to have in one spot. Overall, I would highly recommend Roave to anyone looking to plan their next vacation!`,
    dealyAnimation: "200",
    date_posted: "October 17, 2024"
  },
  {
    id: 15,
    avatar: <PersonCircle size={40} />,
    name: "Amanjot Singh",
    designation: `Roave made the entire process seamless`,
    text: `Roave made the entire process incredibly smooth and stress-free. They found me a top-tier, board-certified clinic for my hair transplant and stem cell procedure, and even negotiated a discounted rate. Everything from the flight and hotel to the procedure itself was pre-booked to fit my needs perfectly. Couldn’t have asked for a better experience. Highly recommend to anyone looking for a true one-stop shop!`,
    dealyAnimation: "200",
    date_posted: "September 23, 2024"
  },
  {
    id: 14,
    avatar: <PersonCircle size={40} />,
    name: "Veronica Franco",
    designation: `Reliable & good deals`,
    text: `I have now booked multiple trips with Roave Travel and the experience is always great! Roave has become my go-to when booking trips because it’s reliable and I always find the best deals when booking through this company. They are always quick to respond and very accommodating to my questions & requests. I would definitely recommend Roave Travel to anyone looking to book their next trip.`,
    dealyAnimation: "200",
    date_posted: "May 29, 2024"
  },
  {
    id: 13,
    avatar: <PersonCircle size={40} />,
    name: "Gurpreet Heer",
    designation: `**Review for Roave Travel**`,
    text: `I recently had the pleasure of working with Roave Travel for my vacation, and I can confidently say it was an outstanding experience! From the initial consultation to the final itinerary, every step was handled with professionalism and care.

    My travel agent, Sanam, was exceptional. He took the time to understand my travel preferences and crafted a plan that met all my needs. Sanam suggested some fantastic destinations and activities that perfectly matched my interests, and I truly appreciated his expertise in finding the best accommodations.
    
    Communication with Roave Travel was seamless. Sanam was always prompt in responding to my questions and was readily available, whether via phone or email. He provided a well-organized itinerary that made navigating our trip stress-free.
    
    What impressed me the most was his attention to detail. Sanam ensured all aspects of our journey were well-coordinated, from flights to local transportation. He even provided great restaurant recommendations that added to our overall experience.
    
    Thanks to Roave Travel, I returned home with wonderful memories and a relaxed spirit. I highly recommend this agency to anyone looking for a hassle-free travel planning experience. I can’t wait to book my next adventure with them!`,
    dealyAnimation: "200",
    date_posted: "April 17, 2025"
  },
  {
    id: 12,
    avatar: <PersonCircle size={40} />,
    name: "Pallav Tandel",
    designation: `Best price and experience`,
    text: `Booked San Diego, Hawaii, and Miami trips with Roave and they have all been absolutely fantastic. The price is unbeatable and the team, Sanam always goes above and beyond to make our trip more memorable. Glad we booked through them and now they’re our go to travel guide 😊`,
    dealyAnimation: "200",
    date_posted: "April 18, 2025"
  },
  {
    id: 11,
    avatar: <PersonCircle size={40} />,
    name: "Geet Bhullar",
    designation: `Amazing experience`,
    text: `Amazing experience! Best travel company`,
    dealyAnimation: "200",
    date_posted: "April 19, 2025"
  },
  {
    id: 10,
    avatar: <PersonCircle size={40} />,
    name: "Ayushi Tandel",
    designation: `Another Great Experience with Roave Travel`,
    text: `I recently booked a trip with Roave Travel for the second time and once again, they exceeded my expectations. From the flights and all-inclusive hotel in Puerto Vallarta to the transportation to and from the airport, every detail was handled smoothly. The booking process was simple and stress-free, and their customer service was incredibly responsive. I also really appreciated that they checked in during the trip to make sure everything was going well. Highly recommend Roave Travel and will definitely be using them again for all future travel!`,
    dealyAnimation: "200",
    date_posted: "March 21, 2025"
  },
  {
    id: 1,
    avatar: <PersonCircle size={40} />,
    name: "Ayushi Tandel",
    designation: "Stress-Free and Seamless Birthday Trip Planning",
    text: `I had an amazing experience booking a birthday trip to Cancun with friends. From start to finish, Sanam made the process feel easy and stress-free. Coordinating a trip for a group can be complicated, but Roave was super flexible and accommodating, ensuring that all our bookings—from traveling from different cities to landing at different times—were handled smoothly. We got an amazing deal for our hotel and for a ziplining/ATV package, and Sanam went above and beyond to make sure all the details were taken care of. If you’re looking for a hassle-free booking experience with excellent customer service, I highly recommend Roave!`,
    dealyAnimation: "200",
    date_posted: "February 04, 2025"
  },
  {
    id: 2,
    avatar: <PersonCircle size={40} />,
    name: "Molly Wu",
    designation: "Roave’s asap customer care fixed our transposition issue like a breeze!",
    text: `Roave travel made my cancun getaway trip incredible! Every detail was planned and their customer care was outstanding. When we needed assistance during an airport shuttle delay, roave was immediately available to help us out and call our car service for additional assistance. My family and I were able to relax knowing we had an itinerary full of fun activities and relaxation.`,
    dealyAnimation: "200",
    date_posted: "February 03, 2025"
  },
  {
    id: 3,
    avatar: <PersonCircle size={40} />,
    name: "Dill Singh",
    designation: "Detail Oriented, Went Beyond Expectations",
    text: `We needed to book a family trip to Hawaii and Roave made the whole process a breeze. Just like the other reviews, not only did they help with the hotel and travel but helped us create a whole itinerary with their recommendations. They took all the details into consideration when booking. The hotel had all the amenities our family was looking for and more. I look forward to booking our next trip with Roave!`,
    dealyAnimation: "200",
    date_posted: "December 13, 2024"
  },
  {
    id: 4,
    avatar: <PersonCircle size={40} />,
    name: "Taran Aulak",
    designation: "Customer satisfaction focused team",
    text: `Customer satisfaction focused team! Deliver what they promise. We got a deal from them to Maldives half the price on other sites!`,
    dealyAnimation: "100",
    date_posted: "October 01, 2024"
  },
  {
    id: 5,
    avatar: <PersonCircle size={40} />,
    name: "Amanpreet Singh",
    designation: "I had an excellent experience booking",
    text: `I had an excellent experience booking my flight through roave.Their team was extremely helpful and responsive, guiding me through the entire process and ensuring I got the best deal possible. They offered great recommendations and were quick to answer all my questions, making the process smooth and stress-free. I will definitely be using their services again for my future travel plans. Highly recommend!`,
    dealyAnimation: "200",
    date_posted: "September 23, 2024"
  },
  {
    id: 6,
    avatar: <PersonCircle size={40} />,
    name: "Priyanshu Rathore",
    designation: "Five star",
    text: `Five star. Good Experience. Good job`,
    dealyAnimation: "300",
    date_posted: "September 19, 2024"
  },
  {
    id: 7,
    avatar: <PersonCircle size={40} />,
    name: "Taran Toor",
    designation: "I had a great time booking with Roave",
    text: `I had a great time booking with Roave. They not only help with flights and hotels but will also go above and beyond to give out recommendations and places to visit during your trip. They make planning a trip a very easy process. I always book my trips with them and the rates they give are much better than what you can find outside. Highly recommend booking with them.`,
    dealyAnimation: "200",
    date_posted: "September 03, 2024"
  },
  {
    id: 8,
    avatar: <PersonCircle size={40} />,
    name: "Amandeep singh",
    designation: "I can’t recommend them enough!",
    text: `I recently had the pleasure of working with Roave Travel Agency, and I can’t recommend them enough! They helped my wife and I find an amazing deal for a getaway to Tulum, Mexico. We stayed at the Tulum Dream Spa Hotel, an all-inclusive paradise that exceeded our expectations. The agency took care of everything, including a seamless airport pick-up, making the whole experience stress-free and enjoyable.

      I’m already working with them again to plan my son’s birthday party in Mexico for 80 people, and so far, the process has been incredibly smooth. Their attention to detail, personalized service, and expertise in finding the best deals make them a top choice for any travel needs. Thank you, Roave, for making our trips so memorable!`,
    dealyAnimation: "200",
    date_posted: "June 12, 2024"
  },
  {
    id: 9,
    avatar: <PersonCircle size={40} />,
    name: "Madhu V",
    designation: "Best All-Inclusive Family Holiday",
    text: `We booked a family holiday through Roave Travel Agency and couldn’t have asked for a better experience. They provided us with multiple options tailored to our preferences and budget. It was clear that our specific needs were carefully considered, resulting in a vacation perfectly customized for us.

    The all-inclusive resort experience was thoughtfully planned to accommodate everyone in our family, from seniors to a toddler, ensuring that everyone had a fantastic time. Before booking, we compared the prices offered by Roave with other major booking sites, and Roave consistently gave us the best deal.
    
    During our vacation, our agent regularly checked in to ensure everything was going smoothly, which added a personal touch to the experience. We had an amazing holiday in Mexico and would highly recommend Roave Travel Agency to all our family and friends!.`,
    dealyAnimation: "200",
    date_posted: "March 18, 2024"
  }
  
];
export const testimonial2 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "100",
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "200",
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "300",
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "400",
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "500",
  },
];

export const testimonial3 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
];
